module.exports = __webpack_public_path__ + "static/media/binus_university_logo.39f23493.png";